<template>
  <section class="page-imprint prose">
    <div class="container">
      <LegalPagesNavigation />

      <h1>Impressum</h1>

      <div class="content">
        <div class="imprint">
          <div class="imprint__column">
            <h4>Webseite</h4>
            <p>
              <TBtnLink to="/" target="_blank">
                {{ concept }}
              </TBtnLink>
            </p>

            <h4>E-Mail</h4>
            <p>
              <TBtnLink :href="`mailto:${conceptEmail}`" target="_blank">
                {{ conceptEmail }}
              </TBtnLink>
            </p>

            <h4>Adresse</h4>
            <p>Prinsenkade 5B, Breda, 4811VB, The Netherlands</p>

            <h4>Telefonnummer</h4>
            <p>
              <TBtnLink href="tel:+31765246243" target="_blank">
                +31765246243
              </TBtnLink>
            </p>

            <h4>Geschäftsführer</h4>
            <p>Frank van Run</p>

            <h4>Verantwortlich für Inhalt</h4>
            <p>Frank van Run</p>

            <h4>Bildmaterial</h4>
            <p>
              <TBtnLink href="https://stock.adobe.com" target="_blank">
                stock.adobe.com
              </TBtnLink>
              •
              <TBtnLink href="https://unsplash.com" target="_blank">
                unsplash.com
              </TBtnLink>
            </p>
          </div>

          <div class="imprint__column">
            <h4>Der Anbieter dieser Website ist</h4>
            <p>Bambelo B.V</p>

            <h4>Hauptsitz</h4>
            <p>Prinsenkade 5B, Breda, 4811VB, The Netherlands</p>

            <h4>E-Mail</h4>
            <p>
              <TBtnLink href="mailto:info@bambelo.com" target="_blank">
                info@bambelo.com
              </TBtnLink>
            </p>

            <h4>Umsatzsteuer ID</h4>
            <p>NL818722356B01</p>

            <h4>Handelskammer</h4>
            <p>20111350</p>

            <h4>Verantwortlich gemäß § 55 RStV</h4>
            <p>Frank van Run</p>
          </div>

          <div class="imprint__column imprint__image">
            <img src="images/imprint.jpg" alt="" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import LegalPagesNavigation from '../LegalPagesNavigation'
import AbstractImprintPage from './AbstractImprintPage'

export default {
  name: 'ImprintPage',

  components: {
    LegalPagesNavigation,
  },

  extends: AbstractImprintPage,

  computed: {
    /**
     * @returns {string}
     */
    conceptEmail() {
      return `info@${this.concept.toLowerCase()}`
    },
  },
}
</script>
